// extracted by mini-css-extract-plugin
export var body = "_gf-0";
export var sectionHeader = "_gf-4";
export var shortcutColumns = "_gf-2";
export var shortcutList = "_gf-1";
export var shortcutSection = "_gf-3";